var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rcp-hit"},[(_vm.parts.hit)?[_vm._v(_vm._s(_vm.parts.before)),_c('mark',[_vm._v(_vm._s(_vm.parts.hit))]),_vm._v(_vm._s(_vm.parts.after))]:[_vm._v(_vm._s(_vm.parts.before))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }